import React from "react";

import { Entity } from "@thewebops/admin-panel";

export default new Entity({
  name: "employee",
  pluralName: "employees",
  pathName: "employees",
  endpoint: "/admin/employees",
  serverName: "employee",
  serverPluralName: "employees",
  displayName: "Employees",
  allowCreate: true,
  allowEdit: true,
  allowDelete: true,
  showRowActions: true,
  showSearch: true,
  // showFiltersInDrawer: true,
  titleField: "name",
  fields: [
    {
      identifier: "id",
      label: "ID",
      accessor: "id",
      inList: true,
      usedToShow: true,
      hideInCreate: true,
      hideInEdit: true,
    },
    {
      identifier: "first_name",
      label: { en: "First Name", ar: "الاسم الاول" },
      accessor: "first_name",
      inList: true,
      type: "string",
      required: true,
    },
    {
      identifier: "last_name",
      label: { en: "Last Name", ar: "الاسم الاخير" },
      accessor: "last_name",
      inList: true,
      type: "string",
      required: true,
    },
    {
      identifier: "email",
      label: { en: "Email", ar: "بريد الالكتروني" },
      accessor: "email",
      inList: true,
      type: "email",
      disabled: (action) => action === "edit",
      required: true,
      usedToShow: true,
    },
    {
      identifier: "target_dashboard",
      label: { en: "Target Dashboard", ar: "لوحة التحكم المقصوده" },
      accessor: "target_dashboard",
      type: "checkbox",
      required: true,
      checkboxConfig: {
        format: "array",
      },
      //TODO: Remove this custom component when the checkbox is fixed
      component: ({ value, field }) => {
        if (!value) return "_";

        const keyValueOptions = field.options.reduce((accum, option) => {
          accum[option.value] = option.label;
          return accum;
        }, {});

        const displayValues = value.map((item) => keyValueOptions[item]).join(", ");
        return <span>{displayValues}</span>;
      },
      options: [
        { value: "eta", label: "ETA" },
        { value: "eda", label: "EDA" },
      ],
    },
    // {
    //   identifier: "target_dashboard",
    //   label: { en: "Target Dashboard", ar: "لوحة التحكم المقصوده" },
    //   accessor: "target_dashboard",
    //   inList: true,
    //   type: "select",
    //   options: [
    //     { value: "eta", label: { en: "ETA", ar: "هيئة الضرائب" } },
    //     { value: "eda", label: { en: "EDA", ar: "هيئة الدواء" } },
    //   ],
    //   required: true,
    // },
    {
      identifier: "job_title",
      label: { en: "Job Title", ar: "المسمى الوظيفي" },
      accessor: "job_title",
      inList: true,
      type: "string",
      hideInCreate: true,
      hideInEdit: true,
    },
    {
      identifier: "dashboard_management",
      label: { en: "Dashboard Management", ar: "ادارة لوحة التحكم" },
      accessor: "dashboard_management",
      type: "select",
      required: true,
      inList: true,
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    {
      identifier: "export_access",
      label: { en: "Export Access", ar: "امكانية تصدير ملفات" },
      accessor: "export_access",
      type: "select",
      defaultValue: false,
      inList: true,
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    {
      identifier: "status",
      label: { en: "Status", ar: "الحالة" },
      accessor: "status",
      inList: true,
      type: "select",
      hideInCreate: true,
      hideInEdit: true,
      options: [
        { value: "pending", label: { en: "Pending", ar: "قيد الانتظار" } },
        { value: "active", label: { en: "Active", ar: "نشط" } },
        { value: "inactive", label: { en: "Inactive", ar: "غير نشط" } },
      ],
      required: true,
    },
    {
      identifier: "active",
      label: "Active",
      accessor: (dataObject) => (dataObject?.active ? true : false),
      hideInCreate: true,
      inList: true,
      type: "select",
      options: [
        {
          value: true,
          label: { en: "Active", ar: "نشط" },
        },
        {
          value: false,
          label: { en: "Inactive", ar: "غير نشط" },
        },
      ],
    }
  ],
});
